export interface TextLocation {
    x: number;
    y: number;
    z: number;
    width: number;
}

export enum TextAlignType {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
}
export class TextAlignTypes {
    public static LEFT: TextAlignType = TextAlignType.LEFT;
    public static CENTER: TextAlignType = TextAlignType.CENTER;
    public static RIGHT: TextAlignType = TextAlignType.RIGHT;
}

export const MEME_TEXT = 'MemeText';

export interface Dimension {
    width: number;
    height: number;
}

export interface Location {
    x: number;
    y: number;
}

export interface Rectangle extends Dimension, Location {
}

export interface Resizable {
    resize(location: Location);
}